module.exports = __webpack_public_path__ + "static/media/C Magazine - Showered with Kindness.6ad7b7fe.pdf";